import "./sbAccordion.scss";
import { useState } from "react";
import Typography from "../Typography";
import { Collapse } from "react-bootstrap";
import ChevronDown from "../../assets/ChevronDown";

const SbAccordion = ({
  headIcon = <></>,
  headTag = <></>,
  subHeading = <></>,
  title,
  children,
  isDefaultOpen,
  isUseParentState,
  isCollapsedFrmParent,
  toggleCollapsedFrmParent,
}) => {
  const [isLocalCollapsed, setLocalCollapsed] = useState(
    isDefaultOpen || false
  );

  const isCollased = isUseParentState ? isCollapsedFrmParent : isLocalCollapsed;

  return (
    <div className="sb-accordion">
      <div
        className="sb-accordion-head"
        onClick={() =>
          isUseParentState
            ? toggleCollapsedFrmParent()
            : setLocalCollapsed((prev) => !prev)
        }
      >
        {headIcon}
        <Typography tag="h3" size="heading-lg" weight="medium">
          {title}
        </Typography>
        {headTag}
        <ChevronDown width={24} height={24} rotate={isCollased ? 180 : 0} />
      </div>
      {subHeading}

      <Collapse in={isCollased}>
        <div>
          <div className="sb-accordion-body">{children}</div>
        </div>
      </Collapse>
    </div>
  );
};

export default SbAccordion;
